export const READ_ALL_NOTIFICATIONS_MUTATION = `
  mutation ReadAllNotificationsMutation {
    me {
      readAllNotifications
    }
  }
`;
